import React from 'react';
import {css} from '@emotion/react';
import { Link } from 'react-router-dom';

const css_base = css`
  border-radius: 16px;
  padding: 5px 25px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  transition: 0.25s all;
`

export const BtnBorder = (props) => {
  const styles = css`
    ${css_base};
    border: 1px solid #000;
    padding: 3px 25px;
    ${props.disabled ? `
      border: 1px solid #CCC;
      color: #CCC;
      cursor: default;
    ` : `
      &:hover {
        background-color: black;
        color: white;
      }
    `}
  `;

  return props.to ? (
    <Link css={styles} to={props.to}>{props.name || props.children}</Link>
  ) : (
    <div css={styles} ref={props.ref} className="btn" tabIndex={props.tabIndex || 0} onClick={() => {! props.disabled && props.action()}} onKeyPress={(ev) => {ev.which == 13 && ! props.disabled && props.action()}}>
        {props.name || props.children}
    </div>
  )
}

export const BtnSubmit = (props) => {
  return (
    <div css={css`
        border: 1px solid ##1A73E8;
        background: #1A73E8;
        color: #fff;
        margin-left: 20px;
        ${css_base};
        &:hover {
          opacity: 0.6;
        }
    `} onClick={() => {! props.disabled && props.action()}}>
        {props.name}
    </div>
  )
}
